import { Component } from '@angular/core';
import { SubNavItem } from '../components/sub-navigation/sub-navigation.component';

@Component({
  selector: 'bwc-educations',
  templateUrl: './educations.component.html',
  styleUrls: ['./educations.component.scss'],
})
export class EducationsComponent {
  subNavItems: SubNavItem[] = [
    { label: 'educations.sub_nav.find', route: '/profile-check/educations' },
    { label: 'educations.sub_nav.saved', route: '/profile-check/educations/saved' },
  ];
}
